<template>
  <v-app>
    <v-app-bar app flat height="80">
      <v-toolbar-title>
        <v-img class="shrink mr-2" contain :src="headerLogoUrl" transition="scale-transition" width="240" height="64"/>
      </v-toolbar-title>
      <v-row justify="center" class="pt-0" v-if="$vuetify.breakpoint.mdAndUp">
        <v-col cols="auto">
          <h3 class="text-center">{{ portalDownload.name }}</h3>
          <div class="text-center">{{ $t('downloadExpires') }} {{ downloadExpireTime }}</div>
        </v-col>
      </v-row>
    </v-app-bar>

    <v-content app>
      <v-row  v-if="$vuetify.breakpoint.smAndDown" justify="center" class="pt-0">
        <v-col cols="auto">
          <h3 class="text-center">{{ portalDownload.name }}</h3>
          <div class="text-center">{{ $t('downloadExpires') }} {{ downloadExpireTime }}</div>
        </v-col>
      </v-row>
      <v-container fluid v-if="portalDownload" app>
        <v-row>
          <v-col cols="12" class="text-right">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" dark v-bind="attrs" v-on="on">
                  {{ $t('downloadZipBtn') }}
                </v-btn>
              </template>
              <v-list>
                <v-list-item link v-for="format in portalDownload.downloadFormats" :key="format.id">
                  <v-list-item-title @click="downloadZip(format.id)">{{ format.name }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <v-divider class="pt-3"></v-divider>
        </v-row>
        <div v-for="item in portalDownload.portalDownloadAssets" v-bind:key="item.id">
          <download-item :item="item" :formats="portalDownload.downloadFormats" @downloadItem="downloadItem"/>
          <v-row>
            <v-divider class="pt-3"></v-divider>
          </v-row>
        </div>
      </v-container>
      <v-container v-else fluid fill-height style="background-color: rgba(255, 255, 255, 0.5);">
        <v-layout justify-center align-center>
          <v-progress-circular size="100" indeterminate color="primary">
          </v-progress-circular>
        </v-layout>
      </v-container>
      <v-footer app bottom fixed padless>
        <v-col cols="12" class="text-center" v-html="portalDownload.footer.htmlBody"></v-col>
      </v-footer>
    </v-content>
    <!--    </v-main>-->
  </v-app>
</template>

<script>
import DownloadItem from "@/components/DownloadItem"
import axios from 'axios'
import Url from '../utils/Url'

function executeDownload(url) {
  let isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
  if (isIE11) {
    window.location = url.urlString
  } else {
    const a = document.createElement('a')
    a.href = url.urlString
    a.click()
    a.remove()
  }
}

export default {
  name: "Download",
  components: {DownloadItem},
  props: {downloadId: {type: String}},
  data: () => ({
    portalDownload: null,
    server: null
  }),
  methods: {
    downloadZip(format) {
      let zipDownloadUrl = new Url.Builder(this.server)
          .addElement("download")
          .addElement("pdz")
          .addElement(this.portalDownload.portalDownloadId)
          .addElement(format)
          .build()
      executeDownload(zipDownloadUrl)
    },

    downloadItem(item) {
      let itemDownloadUrl = new Url.Builder(this.server)
          .addElement("download")
          .addElement("pd")
          .addElement(this.portalDownload.portalDownloadId)
          .addElement(item.itemId)
          .addElement(item.formatId)
          .build()
      executeDownload(itemDownloadUrl)
    },

    setTheme(theme) {
      console.log(theme)
      const dark = theme.dark;
      const light = theme.light;
      Object.keys(dark).forEach(i => {
        this.$vuetify.theme.themes.dark[i] = dark[i];
      });
      Object.keys(light).forEach(i => {
        this.$vuetify.theme.themes.light[i] = light[i];
      });
    }
  },
  computed: {
    headerLogoUrl() {
      return this.server + "download/pd/" + this.downloadId + "/header-logo"
    },
    downloadExpireTime() {
      return this.portalDownload.expireDate.substring(0, 8)
    }

  },

  async created() {
    let backend = await axios.get('/server.json')
    const locale = (navigator && navigator.language) || "de";
    let backendUrl = backend.data.server + "download/pd/" + locale + "/" + this.downloadId
    this.server = backend.data.server
    let portalDownload = await axios.get(backendUrl)
    this.portalDownload = portalDownload.data
    this.setTheme(this.portalDownload.colorTheme.themes)
    this.$i18n.locale = this.portalDownload.locale
    document.title = this.portalDownload.name
  }
}
</script>

<style scoped>

</style>
